module.exports = __webpack_public_path__ + "static/media/hen_searching_food_new.745bc6a2.gif";